import React, { Component } from 'react'
import { Card, CardBody, CardHeader, Button } from 'reactstrap'
import { Link } from 'react-router-dom'
import {connect} from 'react-redux'
import districtAdmin from '../../helpers/users/testing/districtAdmin'
import { Email, Username, Info, Name } from './NewManageUsers/ManagePane/InfoCard/InfoBlockComponents'
import devMode from '../../config/devMode'
class UserProfile extends Component {
  render() {
    const user = devMode ? this.props.user || districtAdmin : this.props.user
    if (!user || !this.props.st.users.testUser) return null
    let {
      firstName,
      lastName,
      fullName,
      username,
      email,
      created,
      lastModified,
      role,
    } = this.props.st.users.testUser 
    let lastlog, res
    if (this.props.st.users.testUser.activity) {
      lastlog = this.props.st.users.testUser.activity.login
      res =  Object.keys(lastlog).sort().pop() 
      res = parseInt(res, 10)
    }
    if (created) {
      created = (new Date(created)).toLocaleDateString()
    }
    if (lastModified) {
      lastModified = (new Date(lastModified)).toLocaleDateString()
    }
    if (res) {
      var lastLogin = (new Date(res)).toLocaleDateString()
    }


    return (
      <Card>
        <CardHeader>User Profile</CardHeader>
        <CardBody>
          <h5 className="card-form-title">
          {`Hello, ${firstName}! View and edit your user profile below.`}
          </h5>
          <ul className="card-list-items">
            <Name>Name: {`${firstName} ${lastName}`}</Name>
            {role === 'Student' && <Username label='Username'>: {username}</Username>}
            {email && <Email label='Email'> {email}</Email>}
            {created && <Info label='Your account was created'>{created}.</Info>}
            {lastModified && <Info label='It was last modified'>{lastModified}.</Info>}
            {lastLogin && <Info label='You last logged in'>{lastLogin}.</Info>}
          </ul>
          <div className="profile-btns">
          <Link to='/profile/edit' className="edit-btn">
            <Button>Edit</Button> 
          </Link> 
          <Link to='/profile/password' className="change-password-btn">
            <Button>Change Password</Button>
          </Link>
          </div>
        </CardBody>
      </Card>
    )
  }
}
export default connect(
  (state) => ({
    user: state.users.testUser,
    st : state
  })
)(UserProfile)


// WEBPACK FOOTER //
// ./src/components/Users/UserProfile.js